import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import tyre_lookup from "../../api/tyres/_lookup";
import {toggle_loader, disable_loader} from '../../theme/_loader';
import Cookies from 'js-cookie'
import swal from 'sweetalert';
import 'swiper/css';

let trap = false;

//indicate whether we want to show higher speeds than the user has selected
let show_higher_speeds = false;

document.addEventListener("DOMContentLoaded", function() {

	const modal = document.getElementById('modal');

	const registration = new Swiper( document.getElementById('open-registration') , {
		centeredSlides: true,
		allowTouchMove: false,
		keyboard: {
			enabled: false
		},
		autoplay: false,
		slidesPerView: 1,
		on: {
			slideChange: function (swiper) {
				if(swiper.realIndex == 3) {
					((swiper.el).parentNode.parentNode).classList.add('!overflow-y-scroll');
				} else {
					((swiper.el).parentNode.parentNode).classList.remove('!overflow-y-scroll');
				}

				((swiper.el).parentNode.parentNode).scrollTop = 0;
			},
		},
	});

	const tyre = new Swiper( document.getElementById('open-tyre-size') , {
		centeredSlides: true,
		allowTouchMove: false,
		keyboard: {
			enabled: false
		},
		autoplay: false,
		slidesPerView: 1
	});

	document.addEventListener('click', function (event) {

		if (event.target.matches('.open-registration')) {
            event.preventDefault(); // Prevent default button behavior
			toggle_search_modal();

            //if this button has a fulfilment type attached to it
            if(event.target.getAttribute('data-type')) {

                console.log(event.target.getAttribute('data-type'));

                //fetch the fulfilment types
                let fulfillment_options = document.querySelectorAll('#modal input[name="fulfilment_option"]');

                //if we have some fulfilment types
                if(fulfillment_options && fulfillment_options.length > 0) {

                    //loop over each fulfilment type
                    for(let i = 0; i < fulfillment_options.length; i++) {

                        //set the value of this fulfilment type to the value of the button
                        fulfillment_options[i].value = event.target.getAttribute('data-type');
                    }
                }
            }

			setTimeout(function(){
                document.querySelector('#open-registration input[name="registration"]').focus();
            }, 200);
        };

		if (event.target.matches('.open-tyre-size') || event.target.matches('.switch-to-tyre-size')) {
            event.preventDefault(); // Prevent default button behavior
			toggle_search_modal('tyre', event.target.matches('.switch-to-tyre-size'));
        };

        if(event.target.matches('#modal-close')) {
			toggle_search_modal();

            //reset the slides
            registration.slideTo(0);
            tyre.slideTo(0);
        };

        if(event.target.matches('.tyre-preview-text')) {
			let target = event.target.dataset.target;

			let select = document.getElementById(target).parentNode;

			if(select) {
				select.scrollIntoView({
					behavior: 'smooth'
				});
				select.classList.add('emphesis');

				setTimeout(function() {
					select.classList.remove('emphesis');
				}, 300);
			}
        };

        if(event.target.matches('.reg-step-1')) {
			registration.slideTo(0);
        };

        if(event.target.matches('.tyre-step-1')) {
			tyre.slideTo(0);
        };

        if(event.target.matches('.reg-step-2')) {

            //get our inputs
			let inputs = get_inputs();

            console.log(inputs);

			if(inputs.registration) {
				document.querySelector('#open-registration input[name="registration"]').classList.remove('tyre-search-error');
				registration.slideTo(1);
				setTimeout(function(){
                    let registration_input = document.querySelector('#open-registration input[name="postcode"]');

                    if(registration_input) {
                        registration_input.focus();
                    }
                }, 200);

			} else {

                //if we have a branch id
                if(inputs.branch_id) {

                    //go to slide 1
                    registration.slideTo(1);

                } else {

                    //find our registration input
                    let registration_input = document.querySelector('#open-registration input[name="registration"]');

                    //add some error styles to this registration field
                    if(registration_input) {
                        registration_input.classList.add('tyre-search-error');
                    }
                }

                
			}
        };

		if(event.target.matches('.tyre-step-2')) {
			let inputs = get_inputs('tyre');

			//if the user has chosen a value on all selects
			if(inputs.sizes.width != "0" && inputs.sizes.profile != "0" && inputs.sizes.rim != "0" && inputs.sizes.speed != "0") {

				//slide to the next page
				tyre.slideTo(1);
				setTimeout(function(){ document.querySelector('#open-tyre-size input[id="postcode"]').focus(); }, 200);
			}
        };

        if(event.target.matches('.reg-step-3')) {
			validate_and_search();

            //find the conditional button
			let search_buttons = document.querySelectorAll('.view-results-conditional');

            //if we have some conditional search buttons
            if(search_buttons && search_buttons.length > 0) {

                //loop over each button
                for(let i = 0; i < search_buttons.length; i++) {

                    //add the disabled class
                    search_buttons[i].classList.add('view-results-disabled');
                }
            }
        };

        if(event.target.matches('.view-results')) {
			event.preventDefault();
			trigger_search_submission();
        };

        if(event.target.matches('.tyre-search-toggle')) {
			event.preventDefault();

            let block = event.target.closest('.tyre-search-cta-block');

            if(block) {
                block.dataset.compact = block.dataset.compact == 'true' ? 'false' : 'true';
            }
        };

	}, false);

	document.addEventListener('keydown', function(event) {

        //if the search modal is open...
        if(document.body.classList.contains('search-modal-open')) {

            //if the escape key has been pressed and the modal is open
            if((event.code == "Escape" || event.code == "Esc")) {

                //close it
                toggle_search_modal('reg');
                return;
            }

            //if the enter key has been pressed
            if(event.code == "Enter" || event.code == "NumpadEnter") {

                //find the active element
                let element = event.target;

                if(element.matches('input[name="registration"]')) {

                    //prevent the default action
                    event.preventDefault();

                    //if we have a value in the registration field
                    if(element.value) {

                        //move to the next slide
                        registration.slideTo(1);

                        //focus on the postcode field
                        setTimeout(function(){
                            document.querySelector('#open-registration input[id="postcode"]').focus();
                        }, 500);
                    }
                }

                if(element.matches('input[name="postcode"]')) {
                    event.preventDefault();

                    if(document.body.classList.contains('modal-registration')) {
                        validate_and_search();
                    } else {
                        trigger_search_submission();
                    }
                }

                if(element.matches('.tyre-lookup-choice')) {
                    event.preventDefault();

                    trigger_search_submission();
                }
            }
		}
	}, false);

    document.addEventListener('click', function (event) {

		//if the clicked element is a play/pause button
		if (event.target.matches('#toggle-search')) {

			event.target.classList.toggle('active');
			let fields = document.getElementById('tyre-search-results-fields-update');

			if(fields) {
				fields.classList.toggle('!-mb-[40rem]');
				fields.classList.toggle('md:!-mb-[20rem]');
				fields.classList.toggle('xl:!-mb-[10rem]');
				fields.classList.toggle('-translate-y-full');
				fields.classList.toggle('opacity-0');
				fields.classList.toggle('invisible');
			}
		}
	});

    document.addEventListener('click', function (event) {

		//if the clicked element is a tyre size choice
		if (event.target.matches('.tyre-lookup-choice')) {

            //find the conditional button
			let search_buttons = document.querySelectorAll('.view-results-conditional');

            //if we have some conditional search buttons
            if(search_buttons && search_buttons.length > 0) {

                //loop over each button
                for(let i = 0; i < search_buttons.length; i++) {

                    //remove the disabled class
                    search_buttons[i].classList.remove('view-results-disabled');
                }
            }
		}
	});

	document.addEventListener('click', function (event) {

		if(document.body.classList.contains('post-type-archive-tyre')) {

			//if the user wants to edit their registration
			if (event.target.id == 'edit-reg') {

                //move to slide 2 (where tyre sizes are available)
				registration.slideTo(2);

                //open the modal
				prepare_search_modal('reg');

                setTimeout(() => {

                    //search for the registration
                    validate_and_search();

                }, 50);
			}

			//if the user wants to edit their postcode and have used registration as their lookup method
			if (event.target.id == 'edit-reg-postcode') {
				prepare_search_modal('reg-postcode');
			}

			//if the user wants to edit their manual tyre search
			if (event.target.id == 'edit-tyres') {

				//reset the modal to slide 1
				tyre.slideTo(0);
				prepare_search_modal('tyres');
			}

			//if the user wants to edit their postcode and have used a manual search as their lookup method
			if (event.target.id == 'edit-tyres-postcode') {
				prepare_search_modal('tyres-postcode');
			}
		}
	});

    //adds a click event listener to the document to allow switching between CTA views
    document.addEventListener('click', function (event) {

        // If the clicked element isn't the button to switch search cta, return
        if ( ! event.target.matches('.tyre-search-cta-view-toggle')) return;

        event.preventDefault();

        //find the container
        let container = event.target.closest('.container');

        if(container) {

            //if the container is in registration view...
            if(container.dataset.view === 'registration') {

                //change the view to tyre
                container.dataset.view = 'tyre';
            } else { //if the container is in tyre view...

                //change the view to registration
                container.dataset.view = 'registration';
            }

            //scroll to the top of the container
            container.scrollIntoView({behavior: 'smooth'});
        }

    }, false);

    //fetch all quick search CTAs
    let quick_search_ctas = document.querySelectorAll('.quick-reg-search');

    //if we have some CTA's to work with
    if(quick_search_ctas && quick_search_ctas.length > 0) {

        //loop over each CTA
        for(let i = 0; i < quick_search_ctas.length; i++) {

            //adds a click event listener to the document to allow a shortcut into the reg lookup process
            quick_search_ctas[i].addEventListener('submit', async function (event) {

                //prevent stadnard form submission
                event.preventDefault();

                //fetch our registration and postode
                let registration = (event.target).querySelector('input[name="registration"]') ? (event.target).querySelector('input[name="registration"]').value : false;
                let postcode = (event.target).querySelector('input[name="postcode"]') ? (event.target).querySelector('input[name="postcode"]').value : false;

                //fetch a brand if it's available, otherwise it's false
                let brand = (event.target).querySelector('input[name="tyre_brand"]') ? (event.target).querySelector('input[name="tyre_brand"]').value : false;

                //fetch a new tab field if it's available, otherwise it's false
                let new_tab = (event.target).querySelector('input[name="new_tab"]') ? true : false;

                //find our form
                let form = document.getElementById('open-registration');

                //pre-set the registration and postcode fields in the main search modal
                if(document.querySelector('#open-registration input[name="registration"]')) {
                    document.querySelector('#open-registration input[name="registration"]').value = registration;
                }

                if(document.querySelector('#open-registration input[name="postcode"]')) {
                    document.querySelector('#open-registration input[name="postcode"]').value = postcode;
                }

                //if we have a brand to add
                if(brand) {

                    //attempt to fetch a brand field
                    let brand_field = document.querySelector('#open-registration input[name="tyre_brand"]');

                    //if the brand field doesn't yet exist...
                    if(!brand_field) {

                        //create a new hidden input field
                        brand_field = document.createElement('input');
                        brand_field.type = 'hidden';
                        brand_field.name = 'tyre_brand';
                        brand_field.value = brand;

                        //append this field to the form
                        document.querySelector('#open-registration').appendChild(brand_field);

                        //fetch it again
                        brand_field = document.querySelector('#open-registration input[name="tyre_brand"]');
                    }

                    //set the value of this field to the brand
                    brand_field.value = brand;
                }

                //if we're opening in a new tab
                if(new_tab) {

                    //set the form target to _blank
                    form.target = '_blank';
                } else { //otherwise we're not supposed to open a new tab

                    //set the form target to _self
                    form.target = '_self';
                }

                //wait for the lookup to complete...
                if(await validate_and_search()) {

                    //open the modal if it's successful
                    toggle_search_modal();
                }
            }, false);
        }
    }

    //apply saved search fields on page load...
    apply_saved_search();

    //use an interval to apply the saved search to the fields every 1000ms
    setInterval(apply_saved_search, 1000);

	function trigger_search_submission() {
		let form;

		if(document.body.classList.contains('modal-registration')) {

            //fetch the form
			form = document.getElementById('open-registration');

            //determine if we're opening in a new tab
            let new_tab = form.getAttribute('target') && form.getAttribute('target') == '_blank';

			//fetch all search inputs
			let inputs = get_inputs('reg');

            //if we don't have a branch id, we need a registration and a postcode
            if(!inputs.branch_id) {

                //if we don't have a registration
                if(!inputs.registration) {

                    //create an error notification
                    swal({
                        title: 'Whoops, something went wrong',
                        text: "We were unable to perform a search due to an issue with your registration number. Please check this and try again.",
                        timer: 6000
                    });

                    //prevent the rest of the execution
                    return;
                } else if(!inputs.postcode) { //if we don't have a postcode

                    //create an error notification
                    swal({
                        title: 'Whoops, something went wrong',
                        text: "We were unable to perform a search due to an issue with your postcode. Please check this and try again.",
                        timer: 6000
                    });

                    //prevent the rest of the execution
                    return;
                }
			}

			//attempt to fetch the selected tyre
			let selected_tyre = form.querySelector('input[name="front"]:checked');

			//if we have a tyre
			if(selected_tyre) {

                //if we're not opening in a new tab...
                if(!new_tab) {

                    //show the loader
                    toggle_loader();
                }

				//get its details via split
				let tyre_details = (selected_tyre.value).split(",");

				//if we have details
				if(tyre_details) {

					//set the inputs we need to populate when we hit search
					let populate_inputs = ['width', 'profile', 'rim', 'speed'];

					//loop over them
					for(let i = 0; i < 4; i++) {

						//find this field
						let field = form.querySelector('input[type="hidden"][name="' + populate_inputs[i] + '"]');

						//if we have a field
						if(field) {

							//set the value to the relevant tyre data (if this is a speed value, add a + after it to indicate we want this speed or higher)
							field.value = tyre_details[i] + (show_higher_speeds && populate_inputs[i] === 'speed' ? '+' : '');
						}
					}

					//attempt to find the input to provide details for the rear search
					let rear = document.querySelector('#open-registration input[name="rear"]');

					//if we have an input
					if(rear && selected_tyre.dataset.rear) {

						//set its details
						rear.value = (selected_tyre.dataset.rear);
					}

                    //if we have a branch ID to add
                    if(inputs.branch_id) {

                        //attempt to fetch a branch id field
                        let branch_field = form.querySelector('input[name="branch_id"]');

                        //if the branch field doesn't yet exist...
                        if(!branch_field) {

                            //create a new hidden input field
                            branch_field = document.createElement('input');
                            branch_field.type = 'hidden';
                            branch_field.name = 'branch_id';
                            branch_field.value = inputs.branch_id;

                            //append this field to the form
                            form.appendChild(branch_field);

                            //fetch it again
                            branch_field = form.querySelector('input[name="branch_id"]');
                        }

                        //set the value of this field to the branch id
                        branch_field.value = inputs.branch_id;
                    }

					form.submit();

                    //if we're opening in a new tab...
                    if(new_tab) {

                        //hide the loader (if it's still here)
                        disable_loader();

                        //close the modal
                        toggle_search_modal();
                    }
				}
			}
		} else if(document.body.classList.contains('modal-tyre-size')) {

            //fetch the inputs
			let inputs = get_inputs('tyre');

            console.log(inputs);

            //find the postcode input
            let postcode_input = document.querySelector('#open-tyre-size input[name="postcode"]');

            //if we don't have a branch id or a postcode
			if(!inputs.branch_id && !inputs.postcode) {

                //if we have a postcode input
                if(postcode_input) {

                    //add some error styles to this postcode field
                    postcode_input.classList.add('tyre-search-error');
                }

				//prevent the rest of the execution
				return;
			} else {

                //if we have a postcode input
                if(postcode_input) {

                    //remove error style from postcode (if present)
                    postcode_input.classList.remove('tyre-search-error');
                }

				//get the form
				form = document.getElementById('open-tyre-size');

                //if we're not opening in a new tab...
                if(!form.querySelector('input[name="new_tab"]')) {

                    //show the loader
                    toggle_loader();
                }

				//submit the form
				form.submit();
			}
		}
	}

	async function validate_and_search() {

        //fetch all inputs
		let inputs = get_inputs();

        //attempt to fetch the registration input
        let registration_input = document.querySelector('#open-registration input[name="postcode"]');

        //if we have a branch id (this bypasses the need for a postcode) OR we have a postcode
		if(inputs.branch_id || !inputs.branch_id && inputs.postcode) {

            //if we have a registration input
            if(registration_input) {

                //remove any error styles
			    registration_input.classList.remove('tyre-search-error');
            }

            //if we have a registration input
			if(inputs.registration && modal && modal.dataset.endpoint) {

				//wait for lookup to complete...
				return await tyre_lookup(modal.dataset.endpoint, inputs.registration, registration);
			}
		} else {

            //if we have a registration input
            if(registration_input) {

                //add some error styles to this postcode field
                registration_input.classList.add('tyre-search-error');
            }

            return false;
		}
	}

	function prepare_search_modal(page, tyre_side = 'both') {

		//build an array of our existing search options for easy reference
		let existing_search = {
			"reg": document.querySelector('#tyre-search-results-fields input[name="registration"]') ? document.querySelector('#tyre-search-results-fields input[name="registration"]').value : false,
			"tyre": document.querySelector('#tyre-search-results-fields input[name="tyre_selection"]') ? document.querySelector('#tyre-search-results-fields input[name="tyre_selection"]').value : false,
			"postcode": document.querySelector('#tyre-search-results-fields input[name="postcode"]') ? document.querySelector('#tyre-search-results-fields input[name="postcode"]').value : false,
		};

		//if the user has made a new selection
		if(existing_search.tyre != page) {

			//if this is a request for tyre-sides, it'll make an external request
			if(page == 'tyre-side') {

				//enable the loader to prevent user interaction while we do this
				toggle_loader(false);
			}

			//run everything else in a timeout as to mask the modal appearing
			setTimeout(function() {

				//update the modal reg with our existing search option
				let modal_reg = document.querySelector('#open-registration input[name="registration"]');
				modal_reg.value = existing_search.reg;

				//update both the modal postcode with our existing search option
				let reg_modal_postcode = document.querySelector('#open-registration input[name="postcode"]');
				let tyre_modal_postcode = document.querySelector('#open-tyre-size input[name="postcode"]');
				reg_modal_postcode.value = existing_search.postcode;
				tyre_modal_postcode.value = existing_search.postcode;

				//fetch all inputs from the modal
				let inputs = get_inputs();

				//if this is a tyres request and it has at least the registration
				if(page == 'tyre-side' && inputs.registration && modal && modal.dataset.endpoint) {

					//perform a revised lookup
					tyre_lookup(modal.dataset.endpoint, inputs.registration, registration)

					//swap back to reg to target the right modal type
					page = 'reg';
				}

				//if the user has done a reg lookup but now wants to edit their postcode
				if(page == 'reg-postcode') {

					//move to the relevent slide
					registration.slideTo(1);

					//open the modal at the reg page
					toggle_search_modal('reg');

					setTimeout(function() {
						document.querySelector('#open-registration input[name="postcode"]').focus();
					}, 300);
				} else if(page == 'tyres-postcode') {

					//move to the relevent slide
					tyre.slideTo(2);

					//open the modal at the reg page
					toggle_search_modal('tyres');

					setTimeout(function() {
						document.querySelector('#open-tyre-size input[name="postcode"]').focus();
					}, 300);
				} else {

					//open the modal at the requested page
					toggle_search_modal(page);
				}
			}, (page == 'tyre-side' ? 500 : 0));
		}
	}

	function get_inputs(mode = "reg") {

		let container = false;

		if(mode == 'reg') {
			container = document.getElementById('open-registration');
		} else {
			container = document.getElementById('open-tyre-size');
		}

		return {
			registration: container.querySelector('input[name="registration"]') ? container.querySelector('input[name="registration"]').value : false,
			postcode: container.querySelector('input[name="postcode"]') ? container.querySelector('input[name="postcode"]').value : false,
			axle: container.querySelector('input[name="tyre_selection"]:checked') ? container.querySelector('input[name="tyre_selection"]:checked').value : false,
            branch_id: container.querySelector('input[name="branch_id"]') ? container.querySelector('input[name="branch_id"]').value : (window.location.search.indexOf('branch_id=') > -1 ? window.location.search.split('branch_id=')[1].split('&')[0] : false),
			sizes: {
				width: container.querySelector('select[name="width"]') ? container.querySelector('select[name="width"]').value : false,
				profile: container.querySelector('select[name="profile"]') ? container.querySelector('select[name="profile"]').value : false,
				rim: container.querySelector('select[name="rim"]') ? container.querySelector('select[name="rim"]').value : false,
				speed: container.querySelector('select[name="speed"]') ? container.querySelector('select[name="speed"]').value : false,
			}
		};
	}
});

export function toggle_search_modal(mode = 'reg', hotswap = false) {

    let open = document.body.classList.contains('search-modal-open');

    //import the focus trap
    const focusTrap = require('focus-trap');

    if(!trap) {

        let read_tyre_modal = document.getElementById('read-tyre-modal');
        let select2_dropdowns = document.getElementById('select2-focus-container');

        let trapped_elements = read_tyre_modal ? ['header', modal, read_tyre_modal, select2_dropdowns] : ['header', modal, select2_dropdowns]

        trap = focusTrap.createFocusTrap(trapped_elements, {
            clickOutsideDeactivates: true
        });
    }

    if(open) {

        //if we're hotswapping the two modals
        if(hotswap) {
            document.body.classList.remove('modal-registration');
            document.body.classList.remove('modal-tyre-size');

            //if we are opening the registration modal
            if(mode == 'reg') {
                document.body.classList.add('modal-registration');

                //access our swiper instance
                let registration = document.getElementById('open-registration').swiper;

                //revert to the initial slide
                registration.slideTo(0);

                setTimeout(function() {

                    //slide to the first proper slide
                    registration.slideTo(1);
                }, 10);

                //slide to the first proper slide
                registration.slideTo(2);
            } else { //if we are opening the tyre size modal
                document.body.classList.add('modal-tyre-size');

                //access our swiper instance
                let tyre = document.getElementById('open-tyre-size').swiper;

                //revert to the initial slide
                tyre.slideTo(0);

                setTimeout(function() {

                    //slide to the first proper slide
                    tyre.slideTo(1);
                }, 100);
            }
        } else {

            trap.deactivate();
            trap = false;

            document.body.style.paddingTop = '';

            //close the modal
            document.body.classList.remove('search-modal-open');

            //when the animation has completed
            setTimeout(function() {

                //remove classes that indicate what type of modal this is
                document.body.classList.remove('modal-registration');
                document.body.classList.remove('modal-tyre-size');
            }, 300);
        }
    } else {
        trap.activate();
        let sticky_target = document.getElementsByClassName('sticky-nav')[0];

        if(sticky_target) {
            let sticky_height = sticky_target.offsetHeight;
            document.body.style.paddingTop = sticky_height + 'px';
        }

        //open the modal
        document.body.classList.add('search-modal-open');

        //if we are opening the registration modal
        if(mode == 'reg') {
            document.body.classList.add('modal-registration');
        } else { //if we are opening the tyre size modal
            document.body.classList.add('modal-tyre-size');
        }
    }
}

export function apply_saved_search() {

    //identify all postcode inputs that haven't been autofilled
    let registrations = document.querySelectorAll('input[name="registration"]:not(.autofilled)');

    //identify all postcode inputs that haven't been autofilled
    let postcodes = document.querySelectorAll('input[name="postcode"]:not(.autofilled)');

    //fetch previous search records (if present)
    let previous_search = Cookies.get('bt_search');

    //if we have some fields to process and access to the previous search records
    if((registrations && postcodes) && (registrations.length > 0 || postcodes.length > 0) && previous_search) {

        //parse the search records
        previous_search = JSON.parse(previous_search);

        //if we have a reg available
        if(previous_search.registration) {

            //if we have some registrations to apply this to
            if(registrations && registrations.length > 0) {

                //loop over each postcode
                for(let i = 0; i < registrations.length; i++) {

                    //if this field is empty
                    if(!registrations[i].value || registrations[i].value == '') {

                        //set this field to the previous search value
                        registrations[i].value = previous_search.registration;
                        registrations[i].classList.add('autofilled');
                    }
                }
            }
        }

        //if we have a postcode available
        if(previous_search.postcode) {

            //if we have some postcodes to apply this to
            if(postcodes && postcodes.length > 0) {

                //loop over each postcode
                for(let i = 0; i < postcodes.length; i++) {

                    //if this field is empty
                    if(!postcodes[i].value || postcodes[i].value == '') {

                        //set this field to the previous search value
                        postcodes[i].value = previous_search.postcode;
                        postcodes[i].classList.add('autofilled');
                    }
                }
            }
        }
    }
}